// Internal
import {
  REQUEST, SUBMIT, SUCCESS, FAILURE,
} from 'shared/constants/actions';
import appTypes from 'shared/utils/actions';

const auth = appTypes.defineAction('auth');

export const AUTHORIZATION = auth.defineAction('AUTHORIZATION',
  [
    'AUTHORIZE',
    'UNAUTHORIZE',
    'SET_TOKEN',
    'REMOVE_TOKEN',
    'SET_TOKEN_MANUAL',
  ]);

export const LOGIN_WITH_EMAIL = auth.defineAction('LOGIN_WITH_EMAIL', [
  SUBMIT,
  SUCCESS,
  FAILURE,
  'TOGGLE_CAPTCHA',
]);

export const LOGIN_WITH_GOOGLE_AUTH2 = auth.defineAction('LOGIN_WITH_GOOGLE_AUTH2', [
  REQUEST,
  SUCCESS,
  FAILURE,
]);

export const LOGIN_WITH_ECPF = auth.defineAction('LOGIN_WITH_ECPF', [
  SUBMIT,
  SUCCESS,
  FAILURE,
]);

export const LOGOUT = auth.defineAction('LOGOUT', [
  'MANUAL',
  'AUTOMATIC',
]);
